



























import Vue, { PropOptions } from 'vue'
import { InputEvent, Message } from '@/interfaces'
import IconTrash from '@/components/icons/IconTrash.vue'
import Button from '@/components/Button.vue'
import InnerHtml from '@/components/InnerHtml.vue'
import { MessageHub } from '../event-hub'

export default Vue.extend({
  components: {
    IconTrash,
    Button,
    InnerHtml,
  },
  data() {
    return {
      value: '',
    }
  },
  props: {
    message: {
      type: Object,
    } as PropOptions<Message>,
    isActive: Boolean,
  },
  methods: {
    handleInnerLinkClick(event: any) {
      if (event.target.search) {
        this.$router.push(event.target.pathname + event.target.search)
        MessageHub.$emit('updateNotifications')
      } else {
        this.$router.push(event.target.pathname)
        MessageHub.$emit('closeNotifications')
      }
    },
  },
})
